import { ChangeEvent, FC, Fragment } from 'react';
import { Blank, Button } from '@doda/io-react/common';
import { IndustryHooksType } from 'components/SearchConditionSettingForm/types';
import { JobCountQuery } from '@doda/common/src/services/getJobCountAPI';
import { SearchCheckboxItem } from 'components/SearchCheckboxList';
import styles from './index.module.scss';

/**
 * 検索条件設定コンポーネント 業種 の Props
 */
interface Props {
  /** 業種関連のフックタイプ */
  industry: IndustryHooksType;
  /** 求人数を更新するための関数 */
  updateJobCount: (currentCondition?: JobCountQuery) => Promise<void>;
  /** モーダルを開くための関数 */
  onClickOpenModal: () => void;
}

/**
 * 検索条件設定コンポーネント 業種
 *
 * @param {Props} props - 業種の検索条件設定に必要なプロパティ
 * @returns {JSX.Element} Reactコンポーネント
 */
export const IndustryContents: FC<Props> = ({
  industry,
  updateJobCount,
  onClickOpenModal,
}) => {
  const {
    industryDisplayList,
    updateIsCheckedIndustryLList,
    updateIsCheckedIndustrySList,
  } = industry;

  // 大分類のチェックボックス押下処理
  const onChangeLListCheckbox = (
    event: ChangeEvent<HTMLInputElement>,
    selectedId: string
  ) => {
    const checkedList = updateIsCheckedIndustryLList(event, selectedId);
    updateJobCount({ industryLId: checkedList });
  };

  // 小分類のチェックボックス押下処理
  const onChangeSListCheckbox = (
    event: ChangeEvent<HTMLInputElement>,
    selectedId: string
  ) => {
    const checkedList = updateIsCheckedIndustrySList(event, selectedId);
    updateJobCount({ industrySId: checkedList });
  };

  return (
    <div className={styles.searchConditionSettingForm__industryContents}>
      <Button
        as="button"
        onClick={onClickOpenModal}
        size="S"
        variant="outline_gray"
      >
        業種を選択
        <Blank color="black" size="XS" />
      </Button>
      <div className={styles['industry-check-list']}>
        {industryDisplayList.map((industryL) => (
          <Fragment key={industryL.id}>
            {industryL.isDisplay && (
              <SearchCheckboxItem
                title={industryL.name}
                value={industryL.id}
                isChecked={industryL.isChecked}
                onChange={(event) => onChangeLListCheckbox(event, industryL.id)}
                size="L"
              />
            )}
          </Fragment>
        ))}
        {industryDisplayList.map((industryL) => (
          <Fragment key={industryL.id}>
            {industryL.industrySList.map((industryS) => (
              <Fragment key={industryS.id}>
                {industryS.isDisplay && (
                  <div className={styles['industry-check-list__small']}>
                    <SearchCheckboxItem
                      title={industryS.name}
                      value={industryS.id}
                      isChecked={industryS.isChecked}
                      onChange={(event) =>
                        onChangeSListCheckbox(event, industryS.id)
                      }
                      size="L"
                    />
                    <span
                      className={styles['industry-check-list__small__label']}
                    >
                      <span>-</span>
                      {industryL.name}
                    </span>
                  </div>
                )}
              </Fragment>
            ))}
          </Fragment>
        ))}
      </div>
    </div>
  );
};
